import React from 'react'
import { FaArrowRight } from 'react-icons/fa';
import BlogsTeams from '../../components/blogs/BlogsTeams';
import './Blogs.css';
import CommentSection from '../../components/blogs/BlogComments';

const BlogsTeam = () => {

    const heroContent = {
        title: "Blog",
        subtitle: "",
        description: "",
        buttonText: "Explore Services"
    };

    return (
        <>

            <section
                className="equipment-rental-hero"
                style={{
                    background: 'radial-gradient(circle, #ffffff 0%, #f8d4d4 100%)'
                }}>
                <div className="container h-100">
                    <div className="row justify-content-center align-items-center text-center h-100">
                        <div className="col-md-8">
                            <h1 className="mb-3 mt-3">{heroContent.title}</h1>
                            <h3 className="mb-4" style={{ color: '#EF4444' }}>
                                {heroContent.subtitle}
                            </h3>
                            <p className="mb-4" style={{ color: '#000' }}>
                                {heroContent.description}
                            </p>
                            <button
                                className="btn btn-primary mt-3 mb-5"
                                style={{
                                    backgroundColor: '#B91C1C',
                                    borderRadius: '50px',
                                    color: 'white',
                                    padding: '10px 30px',
                                    border: '0'
                                }}
                            >
                                {heroContent.buttonText} <FaArrowRight className="ms-2" />
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <BlogsTeams />
            <CommentSection />

        </>
    )
}

export default BlogsTeam